import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { environment } from '../../../environments/environment'
import { TargetApiRoutes } from '../enums/target-api-routes.enum'
import { Environment } from '../interfaces/environment.interface'
import { AggregationGroup } from '../interfaces/visualizations/aggregation-group.interface'
import { Aggregation } from '../interfaces/visualizations/aggregation.interface'
import { EnvironmentService } from './environment.service'
import { IncentiveFamily } from '../enums/incentive.family'

@Injectable({
  providedIn: 'root'
})
export class VisualizationService {
  environment: Environment

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  listMainVisualizations(): Promise<{
    aggregations: Aggregation[]
    otherAggregation: Aggregation
  }> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Visualizations}`
      )
    ) as Promise<{ aggregations: Aggregation[]; otherAggregation: Aggregation }>
  }

  listIndicatorVisualizations(params? : {dataset? : IncentiveFamily}): Promise<{
    aggregationGroups: AggregationGroup[]
  }> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Indicators}`, {
          params
        }
      )
    ) as Promise<{
      aggregationGroups: AggregationGroup[]
    }>
  }
}
